import { useState } from "react";
import useAddEmployeeAdOverrideGroup from "../hooks/useAddEmployeeAdOverrideGroup";
import { toast } from "components/toastNotification";
import TextInput from "components/TextInput";
import ConfirmBoxModal from "components/ConfirmBoxModal";
import Button from "components/Button";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import MaterialTableTS from "components/tables/MaterialTableTS";

export const EmployeeAdOverrideGroup = ({ setIsAddState, adOverrideData }) => {
  const addEmployeeAdOverrideGroup = useAddEmployeeAdOverrideGroup();
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isExist, setIsExist] = useState(false);
  const [hasValue, setHasValue] = useState(false);
  const defaultValue = {
    adoverrideGroupName: "",
    isActive: 0,
  };
  const [newData] = useState([defaultValue]);

  //#region Handle Add Override
  const handleAddAdOverride = (source, fieldname, inputvalue) => {
    setIsExist(false);
    inputvalue = inputvalue.trim();

    if (source === "AdOverrideGroup" && fieldname === "adoverrideGroupName") {
      setChanged(true);
      const result = adOverrideData?.data?.find(
        (x) => x.adoverrideGroupName?.toLowerCase() === inputvalue.toLowerCase()
      );
      if (result) {
        setIsExist(true);
      } else {
        newData.map((x) => (x.adoverrideGroupName = inputvalue));
      }
      inputvalue === "" ? setHasValue(false) : setHasValue(true);
    }
  };
  //#endregion

  //#region Handle Save
  const handleSave = (newData) => {
    if (!changed) {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setOpenModal(false);
      return;
    }

    if (isExist) {
      toast.fire(
        "Saving Failed",
        "Employee AD Override Group already exists.",
        "error"
      );
      setOpenModal(false);
      return;
    }

    if (!newData?.some((x) => x.adoverrideGroupName)) {
      toast.fire(
        "Saving Failed",
        "All required fields must be filled!",
        "error"
      );
      setOpenModal(false);
      return;
    }

    addEmployeeAdOverrideGroup(newData);
    setIsAddState(false);
    setOpenModal(false);
  };
  //#endregion

  //#region Columns
  type Columns = {
    title: string;
    field?: string;
    alight?: "center";
    render: (rowData: any) => JSX.Element;
  };

  const matColumns: Columns[] = [
    {
      title: "AD Override Group",
      field: "adoverrideGroupName",
      render: (rowData) => {
        return (
          <div className="grid-cols-3 grid ">
            <TextInput
              defaultValue={rowData.adoverrideGroup}
              value={undefined}
              onChange={(inputdata) =>
                handleAddAdOverride(
                  "AdOverrideGroup",
                  "adoverrideGroupName",
                  inputdata.target.value
                )
              }
            />
          </div>
        );
      },
    },
  ];
  //#endregion

  return (
    <div className="">
      <div className="w-full">
        <ConfirmBoxModal
          ModalTitle="Add Employee AD Override Group"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(newData);
          }}
          cancelButtonRef={undefined}
        />
        <div className=" px-3 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold">
              Add New Employee AD Override Group
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <Button
                className={`flex items-center shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasValue ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasValue}
                onClickFunction={() => setOpenModal(true)}
              >
                <CheckCircleIcon className="h-4 w-4" />
                <div className="text-xs3 font-normal self-center -mt-px">
                  Save
                </div>
              </Button>
              <Button
                className="flex items-center text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClickFunction={() => {
                  setIsAddState(false);
                }}
                disabled={undefined}
              >
                <XCircleIcon className="h-4 w-4" />
                <div className="text-xs3 font-normal self-center -mt-px">
                  Cancel
                </div>
              </Button>
            </div>
          </div>

          <div className=" h-0.5 w-full border-b-2 border-secondary "></div>

          <div className=" w-full py-2  ">
            <MaterialTableTS
              columns={matColumns}
              data={newData}
              paging={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeAdOverrideGroup;
